// Centralized API base URL resolver for frontend
const getApiBaseUrl = () => {
  // In production on Vercel, serverless functions live under /api
  if (process.env.NODE_ENV === 'production') return '/api';

  // In development, allow overriding via env; otherwise default to /api
  // Use vercel dev for local testing, or set REACT_APP_API_URL
  return process.env.REACT_APP_API_URL || '/api';
};

export default getApiBaseUrl;

